import styled from 'styled-components';

/* Full-bleed diagnostics footer — pinned at the bottom of the equipment
   card, spanning its full inner width edge to edge, rounded to match the
   card's bottom corners. */
export const Content = styled.div`
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 12px 20px;
  background: #12171c;
  border-top: 1px solid #2c353d;
  border-radius: 0 0 14px 14px;
  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.35);
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 6px 8px;
`;
